import { stringify } from 'query-string';

import { useAuth } from '@dashboard/context/AuthContext/AuthContext';
import { fetchInfinite, fetcher } from '@dashboard/services/request';

async function getSubmissions(sellerId, query, token) {
  const res = await fetcher(`/sellers/${sellerId}/submissions?${stringify(query)}`, token);

  return res;
}

async function getInfiniteSubmissions(sellerId, query, token) {
  return fetchInfinite(`/sellers/${sellerId}/submissions?${stringify(query)}`, token);
}

export default function useSubmissionQueries() {
  const { token } = useAuth();

  return {
    getInfiniteSubmissions: (sellerId, query) => getInfiniteSubmissions(sellerId, query, token),
    getSubmissions: (sellerId, query) => getSubmissions(sellerId, query, token),
  };
}
